<template>
	<div v-if="listingDetails">
		<b-container v-if="!isListingDetails" fluid class="listing-header-action">
			<b-row>
				<b-col class="text-center">
					<h1>{{ $t('listingDetail.licensedToDistubet') }}</h1>
				</b-col>
			</b-row>
			<b-row
				class="button-div no-gutters justify-content-center align-items-center"
			>
				<b-col class="text-center pr-md-3 pl-md-3">
					<b-button
						id="showModal"
						@click="goBackApprovalScreen"
						class="btn-submit-info"
					>
						{{ $t('nextPg') }}</b-button
					>
				</b-col>
				<b-col class="text-center pr-3 pl-3">
					<b-button
						id="showModal"
						@click="showModal"
						class="btn-submit-info reject-button"
						>{{ $t('userDashboard.userManage.disapproval') }}</b-button
					>
				</b-col>
				<b-col class="text-center pr-md-3 pl-md-3">
					<b-button id="onApprove" @click="onApprove" class="btn-submit-info">{{
						$t('listingDetail.approve')
					}}</b-button>
				</b-col>
			</b-row>
		</b-container>
		<Header />
		<TitlePage
			:categoryId="listingDetails.listing_category.listing_category_parent&&listingDetails.listing_category.listing_category_parent.id?listingDetails.listing_category.listing_category_parent.id:listingDetails.listing_category.id"
		/>
		<div class="content-listing-detail">
			<b-container fluid="xl">
				<b-row align-h="between" class="listing-detail-page-header d-md-flex">
					<b-col class="pd-lr-7 w340" align-self="center">
						<a
							@click="
								redicrectPageSearch(
									listingDetails.listing_category.listing_category_parent&&
									listingDetails.listing_category.listing_category_parent.id?listingDetails.listing_category.listing_category_parent.id:listingDetails.listing_category.id,
									listingDetails.listing_category.listing_category_parent&&listingDetails.listing_category.listing_category_parent.name?listingDetails.listing_category.listing_category_parent.name:listingDetails.listing_category.name
								)
							"
							style="cursor:pointer;"
						>
							<span>{{
								listingDetails.listing_category &&
								listingDetails.listing_category.listing_category_parent
									? $t(listingDetails.listing_category.listing_category_parent.name)
									: ''
							}}</span>
							>
							<span>{{
								listingDetails.listing_category &&
								listingDetails.listing_category.name
									? $t(listingDetails.listing_category.name)
									: ''
							}}</span>
						</a>
					</b-col>
					<b-col class="pd-lr-7" align-self="center" v-if="!isMobile">
						<div class="wrap-btn text-right">
							<template v-if="$root.isAuthenticated">
								<UserMenuDropdown :userName="userName" />
								<router-link
									class="btn-post d-none d-md-inline-block"
									id="addListing"
									:to="$i18nRoute({ name: 'add-listing' })"
								>
									<PlaylistPlusIcon />
									{{ $t('searchScreen.postAds') }}
								</router-link>
							</template>
							<template v-else>
								<b-button
									id="login"
									@click="openLogin"
									class="btn-login btn-item"
								>
									<IconLogin />
									{{ $t('login') }}
								</b-button>
								<b-button
									class="register-member btn-item"
									id="signUp"
									@click="openLogin"
								>
									<IconUserPlus />
									{{ $t('signup') }}
								</b-button>
							</template>
						</div>
					</b-col>
				</b-row>

				<!-- LISTING DETAIL -->
				<ListingDetail
					:listingDetailsFront="listingDetails"
					:verticalAds="verticalAds"
					:adsUnderDescription="adsUnderDescription"
				/>
				<b-row v-if="isListingDetails" class="related-div">
					<template v-if="listingSellerDetail.length > 3">
						<b-col cols="12" class="wrap-card-1">
							<label class="title-card">{{
								$t('listingDetail.otherProductSeller')
							}}</label>
						</b-col>
						<div class="d-sm-block w-100">
							<b-col cols="12" class="wrap-card-1">
								<div class="wrapper">
									<template v-for="(item, index) in listingSellerDetail">
										<div
											class="item"
											:class="{
												'item-google-image': randomADSSellerDetail == item.id
											}"
											v-bind:key="index"
										>
											<Card
												:url-image="item.url_feature_image"
												:province="
													item.province && item.province.id
														? item.province.name
														: '--'
												"
												:district="
													item.district && item.district.id
														? item.district.name
														: '--'
												"
												:listing_attributes_details="
													item.listing_attributes_details
												"
												:fav="parseInt(item.fav) == 0 ? false : true"
												:title="item.title"
												:price="item.price"
												:listingPremium="item.listing_premiums"
												:id="item.id"
												:showGoogleAds="randomADSSellerDetail == item.id"
												:typeAds="category"
												:agency_profile_image="item.agency_profile_image"
											/>
										</div>
									</template>
								</div>
							</b-col>
						</div>
					</template>
					<template v-if="listingInteresting.length > 0">
						<b-col cols="12" class="wrap-card-1">
							<label class="title-card">{{
								$t('listingDetail.otherInterestingProducts')
							}}</label>
						</b-col>
						<div class="d-sm-block w-100">
							<b-col cols="12" class="wrap-card-1">
								<div class="wrapper">
									<template v-for="(item, index) in listingInteresting">
										<div
											class="item"
											:class="{
												'item-google-ads': randomADSInteresting == item.id
											}"
											v-bind:key="index"
										>
											<Card
												:url-image="item.url_feature_image"
												:province="
													item.province && item.province.id
														? item.province.name
														: '--'
												"
												:district="
													item.district && item.district.id
														? item.district.name
														: '--'
												"
												:listing_attributes_details="
													item.listing_attributes_details
												"
												:fav="parseInt(item.fav) == 0 ? false : true"
												:title="item.title"
												:price="item.price"
												:listingPremium="item.listing_premiums"
												:id="item.id"
												:showGoogleAds="randomADSInteresting == item.id"
												:typeAds="category"
												:agency_profile_image="item.agency_profile_image"
											/>
										</div>
									</template>
								</div>
							</b-col>
						</div>
					</template>
				</b-row>
				<b-row>
					<b-col cols="12" class="wrap-link-more" v-if="!isMobile">
					<ul class="ul-link-more text-center">
						<li @click="gotoFAQ">
						<router-link
							id="frequentlyAskedQuestions"
							:to="
							$i18nRoute({ name: 'faq' }) +
							'#frequently-asked-questions'
							"
							>{{ $t("home.frequentlyAskedQuestions") }}</router-link
						>
						</li>
						<li>
						<router-link
							id="termsOfuse"
							:to="$i18nRoute({ name: 'faq' }) + '#terms-of-use'"
							>{{ $t("home.termsOfuse") }}</router-link
						>
						</li>
						<li>
						<router-link
							id="privacyPolicy"
							:to="$i18nRoute({ name: 'faq' }) + '#privacy-policy'"
							>{{ $t("home.privacyPolicy") }}</router-link
						>
						</li>
						<li>
						<router-link
							id="listingPolicy"
							:to="$i18nRoute({ name: 'faq' }) + '#listing-policy'"
							>{{ $t("home.listingPolicy") }}</router-link
						>
						</li>
						<li>
						<router-link
							id="advertise-withus-button"
							:to="$i18nRoute({ name: 'ads' })"
							target="_blank"
							>{{ $t("home.advertiseWithUs") }}</router-link
						>
						</li>
						<li>
						<router-link
							id="contactUs"
							:to="$i18nRoute({ name: 'faq' }) + '#contact-us'"
							>{{ $t("home.contactUs") }}</router-link
						>
						</li>
						<li>
						<div
							id="contactUs"
							style="cursor: pointer;"
							@click="disclaimer=true"
							>{{ $t("disclaimer") }}</div
						>
						</li>
						<li>
							<router-link
								id="Activities"
								:to="$i18nRoute({ name: 'topics/how-to-post-listing' })"
								target="_blank"
								>{{ $t("Activities") }}</router-link
							>
						</li>
					</ul>
					</b-col>
					<b-col cols="12" class="wrap-link-more" v-else>
					<ul class="ul-link-more text-center d-flex flex-row align-self-start align-items-start justify-content-around flex-wrap">
						<div class="ul-link-div">
						<li>
							<router-link
							id="frequentlyAskedQuestions"
							:to="
								$i18nRoute({ name: 'faq' }) +
								'#frequently-asked-questions'
							"
							>
							{{ $t("home.frequentlyAskedQuestions") }}
							</router-link>
						</li>
						<li>
							<router-link
							id="termsOfuse"
							:to="$i18nRoute({ name: 'faq' }) + '#terms-of-use'"
							>{{ $t("home.termsOfuse") }}</router-link
							>
						</li>
						<li>
							<router-link
							id="privacyPolicy"
							:to="$i18nRoute({ name: 'faq' }) + '#privacy-policy'"
							>{{ $t("home.privacyPolicy") }}</router-link
							>
						</li>
						<li>
						<div
							id="contactUs"
							style="cursor: pointer;"
							@click="disclaimer=true"
							>{{ $t("disclaimer") }}</div
						>
						</li>
						</div>
						<div class="ul-link-div">
						<li>
						<router-link
							id="listingPolicy"
							:to="$i18nRoute({ name: 'faq' }) + '#listing-policy'"
							>{{ $t("home.listingPolicy") }}</router-link
						>
						</li>
						<li>
						<router-link
							id="advertise-withus-button"
							:to="$i18nRoute({ name: 'ads' })"
							>{{ $t("home.advertiseWithUs") }}</router-link
						>
						</li>
						<li>
							<router-link
								id="contactUs"
								:to="$i18nRoute({ name: 'faq' }) + '#contact-us'"
								>{{ $t("home.contactUs") }}</router-link
							>
						</li>
						<li>
							<router-link
								id="Activities"
								:to="$i18nRoute({ name: 'topics/how-to-post-listing' })"
								target="_blank"
								>{{ $t("Activities") }}</router-link
							>
						</li>
						
						</div>
					</ul>
					</b-col>
				</b-row>
			</b-container>
		</div>
		
		<Footer
			:categoryId="listingDetails.listing_category.listing_category_parent&&listingDetails.listing_category.listing_category_parent.id?listingDetails.listing_category.listing_category_parent.id:listingDetails.listing_category.id"
			:adsFooter="adsFooter"
		/>
		<!-- MODAL -->
		<b-modal id="modal-not-approved" centered hide-footer hide-header>
			<b-container fluid>
				<b-row class="mb-1 text-center">
					<div @click="hideModal" class="close-modal">
						<CloseIcon />
					</div>
					<div class="title">
						{{ $t('approveListing.modal.reasonsDisapproval') }}
					</div>
					<br />
					<div class="wrapper" style="width:100%;">
						<b-dropdown class="input-choose" no-flip>
							<template v-slot:button-content>
								<span>
									{{ $t('listingDetail.chooseReason') }}
									<ChevronDownIcon />
								</span>
							</template>
							<b-dropdown-item
								v-for="item in rejectOption"
								:key="item.value"
								@click="onChangeRejectMessage(item.value)"
								>{{ $t(item.value) }}</b-dropdown-item
							>
						</b-dropdown>
					</div>
					<b-form-textarea
						id="reasons-input"
						:placeholder="$t('listingDetail.chooseReason')"
						rows="4"
						no-resize
						v-model="rejectMessage"
					></b-form-textarea>
					<div class="wrap-btn-send" @click="onReject">
						<b-button id="onReject" class="btn-send">{{
							$t('approveListing.modal.send')
						}}</b-button>
					</div>
				</b-row>
			</b-container>
		</b-modal>
		<b-modal
			id="disclaimer"
			size="lg"
			v-model="disclaimer"
			centered
			hide-header
			hide-footer
			>
			<div @click="disclaimer = false" class="close-modal text-right" style="cursor: pointer;"><CloseIcon /></div>
			<p class="text mt-20">
				{{$t('ข้อสงวนสิทธิ์ (Disclaimers)')}}
				<br />
			</p>
			<p class="text" style="font-size: 16px; text-align: left; overflow-wrap: break-word;"
			v-html="$t('ข้อมูลและเนื้อหาทั้งหมดที่ปรากฏใน นี้ อยู่ภายใต้ลิขสิทธิ์ของบริษัทพร็อพเพอร์ดีเป็นผู้ดูแลรับผิดชอบทั้งหมด หากพบปัญหามีข้อสงสัย แจ้งแก้ไขข้อมูล ลงโฆษณา หรือประสานงานใดๆ กรุณาติดต่อที่')"></p>
			<p class="text" style="font-size: 16px; text-align: left; overflow-wrap: break-word;" v-html="$t('ทั้งนี้ บริษัท เทรนด์ วี จี 3 จำกัด ไม่มีส่วนเกี่ยวข้องกับข้อมูลและเนื้อหาดังกล่าว ไม่มีข้อผูกพันสัญญา หรือข้อตกลงใดๆ กับการใช้บริการของท่าน และไม่รับผิดชอบต่อความเสียหายใดๆ ที่เกิดขึ้น ไม่ว่าโดยทางตรงหรือทางอ้อมอันเนื่องมาจากข้อมูล สินค้า หรือ บริการที่เสนอบนเว็บไซต์ marketplace.khaosod.co.th นี้ ทุกกรณี')"><br />
			</p>
		</b-modal>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

import Header from '@/components/ui/header';
import Card from '@/components/card';
import Footer from '@/components/ui/footer';
import TitlePage from '@/components/ui/titlePage';
import UserMenuDropdown from '@/components/ui/UserMenuDropdown';
import ListingDetail from '@/components/listing/listingDetail/ListingDetail';

// Icons
import IconUserPlus from '@/components/icons/IconUserPlus/index';
import IconLogin from '@/components/icons/IconLogin/index';
import PlaylistPlusIcon from 'vue-material-design-icons/PlaylistPlus.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';

export default {
	components: {
		Header,
		Card,
		Footer,
		TitlePage,
		UserMenuDropdown,
		ListingDetail,
		IconUserPlus,
		IconLogin,
		PlaylistPlusIcon,
		CloseIcon,
		ChevronDownIcon
	},
	props: {
		msg: String
	},
	data() {
		return {
			disclaimer:false,
			adsFooter: null,
			listingDetails: null,
			ShowRejectAcceptButton: false,
			isListingDetails: this.$route.name === 'ListingDetail' ? true : false,
			category: 'marketPlace',
			locationIdForCardAds: 0,
			randomADSSellerDetail: 0,
			randomADSInteresting: 0,
			verticalAds: {
				image: '',
				website: '#',
				advertisment_location: {
					google_on: true,
					google_ad_key: null
				}
			},
			adsUnderDescription: {
				image: '',
				website: '#',
				advertisment_location: {
					google_on: true,
					google_ad_key: null
				}
			},
			rejectOption: [
				{
					value: this.$t(
						'listingDetail.Thank you for posting Please check your announcement We only allow products located in Thailand'
					)
				},
				{
					value: this.$t(
						'listingDetail.Thank you for posting Please check your announcement We detected duplicate announcements'
					)
				},
				{
					value: this.$t(
						'listingDetail.Thank you for posting Please check your announcement must be in Thai or English Please edit and resubmit Thanks'
					)
				},
				{
					value: this.$t(
						'listingDetail.Thank you for posting Please check your announcement Avoid political opinions'
					)
				},
				{
					value: this.$t(
						'listingDetail.Thank you for posting Please check your announcement does not meet the terms of our posting policy'
					)
				},
				{
					value: this.$t(
						'listingDetail.Thank you for posting Please check your announcement We only allow products with images Please upload at least one image of your product'
					)
				}
			],
			rejectMessage: '',
			userName:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).display_name
					? JSON.parse(localStorage.getItem('user_profile')).display_name
					: '',
			isAdmin:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).admin_type.name ==
					'Admin'
					? true
					: false
		};
	},

	metaInfo() {
		return {
			// title: this.listingDetails.title,
			titleTemplate:
				this.listingDetails && this.listingDetails.title
					? this.listingDetails.title
					: '',
			meta: [
				{
					property: 'description',
					content:
						this.listingDetails && this.listingDetails.description
							? this.listingDetails.description
							: ''
				},
				{
					vmid: 'type',
					property: 'og:type',
					content: 'article'
				},
				{
					property: 'og:description',
					content:
						this.listingDetails && this.listingDetails.description
							? this.listingDetails.description
							: ''
				},
				{
					vmid: 'description',
					vmid: 'title',
					property: 'og:title',
					content:
						this.listingDetails && this.listingDetails.title
							? this.listingDetails.title
							: ''
				},
				{
					vmid: 'url',
					property: 'og:url',
					content: `${window.location.origin}${this.$router.currentRoute.fullPath}/share`
				},
				{
					vmid: 'image',
					property: 'og:image',
					content:
						this.listingDetails && this.listingDetails.url_feature_image
							? this.listingDetails.url_feature_image
							: ''
				},
				{
					name: 'twitter:title',
					content:
						this.listingDetails && this.listingDetails.title
							? this.listingDetails.title
							: ''
				},
				{
					name: 'twitter:description',
					content:
						this.listingDetails && this.listingDetails.description
							? this.listingDetails.description
							: ''
				},
				{
					name: 'twitter:image',
					content:
						this.listingDetails && this.listingDetails.url_feature_image
							? this.listingDetails.url_feature_image
							: ''
				},
				{
					name: 'twitter:card',
					content: 'summary'
				},
				{
					property: 'og:article:published_time',
					content: new Date()
				},
				{
					property: 'article:published_time',
					content: new Date()
				},
				{
					property: 'article:modified_time',
					content: new Date()
				},
				{
					property: 'article:modified_time',
					content: new Date()
				},
				{
					property: 'og:image:width',
					content: 832
				},
				{
					property: 'og:image:height',
					content: 462
				},
				{
					property: 'og:site_name',
					content: 'https://marketplace.khaosod.co.th/th'
				},
				{
					property: 'fb:app_id',
					content: '374448816898457'
				},
				{
					property: 'og:type',
					content: 'article'
				}
			]
		};
	},
	methods: {
		...mapActions('ListingDetailController', [
			'GET_LISTING_INTERESTINGS',
			'GET_LISTING_SELLER_DETAIL_ORTHER',
			'GET_LISTING_DETAILS_FOR_FRONT'
		]),
		...mapActions('ListingAdminController', [
			'ADMIN_GET_LISTING_DETAIL',
			'ADMIN_APPROVE_LISTING',
			'ADMIN_REJECT_LISTING'
		]),
		...mapActions('UserController', ['SHOW_NEW_TAB_LOGIN', 'isTablet']),
		...mapActions('CategoryController', ['GET_TEXT_SEARCH', 'GET_ID_ATTR']),
		...mapActions('AdsController', ['GETADS_FOR_PUBLIC_WEBSITE']),
		...mapMutations('ListingAdminController', [
			'SET_ADMIN_RENEW_LISTING_STATUS',
			'SET_ADMIN_REJECT_LISTING_STATUS'
		]),
		openLogin() {
			this.$root.signIn();
		},
		gotoFAQ() {
			this.$store.dispatch("FavouriteController/GET_FAQ", false);
		},
		async onApprove() {
			const result = await this.ADMIN_APPROVE_LISTING({
				id: this.$route.params.id
			});
			if (result.success) {
				this.$router.push(
					this.$i18nRoute({
						name: 'admin-approve-listing'
					})
				);
			}
		},
		openThairathLogin() {
			this.SHOW_NEW_TAB_LOGIN(this.$i18n.locale);
		},

		redicrectPageSearch(value, title) {
			this.GET_ID_ATTR({
				value: value,
				title: title
			});
			if (this.textSearch == '' || this.textSearch == null) {
				this.GET_TEXT_SEARCH('');
			}
			this.$router.push(this.$i18nRoute({ name: 'search' }));
		},
		onReject() {
			if (this.rejectMessage != '') {
				this.ADMIN_REJECT_LISTING({
					id: this.$route.params.id,
					comment: this.rejectMessage
				});
			}
		},
		onChangeRejectMessage(val) {
			this.rejectMessage = val;
		},
		showModal() {
			this.$bvModal.show('modal-not-approved');
		},
		hideModal() {
			this.$bvModal.hide('modal-not-approved');
		},
		goBackApprovalScreen() {
			this.$router.push(
				this.$i18nRoute({
					name: 'admin-approve-listing'
				})
			);
		},
		getVerticleAds(locationId) {
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: locationId
			})
				.then(result => {
					if (result.data) {
						this.verticalAds = result.data;
					}
				})
				.catch(err => {});
		},
		getMobileAds(locationId) {
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: locationId
			})
				.then(result => {
					if (result.data) {
						this.adsUnderDescription = result.data;
					}
				})
				.catch(err => {});
		},
		getListingDetails() {
			let prms = {
				take: 10,
				page: 1
			};
			if (this.$route.name === 'ListingDetail') {
				if (this.textSearch != null || this.textSearch != '') {
					prms = {
						id: this.$route.params.id,
						keyword: this.textSearch != null ? this.textSearch : ''
					};
				} else {
					prms = {
						id: this.$route.params.id
					};
				}
				this.GET_LISTING_DETAILS_FOR_FRONT(prms).then(res => {
					const details = res.data.data;
					if (details.user_id && details.user && details.user.id) {
						this.GET_LISTING_SELLER_DETAIL_ORTHER({
							user_id: details.user_id,
							listing_id: this.$route.params.id,
							take: 4,
							page: 1
						});
					}
					let locationIdForCardAds = 16;
					let locationId = 9;
					if (details.listing_category.listing_category_parent.id == 1) {
						locationIdForCardAds = 16;
						locationId = 18;
						this.category = 'marketPlace';
					}
					if (details.listing_category.listing_category_parent.id == 2) {
						locationIdForCardAds = 25;
						locationId = 27;
						this.category = 'realEstate';
					}
					if (details.listing_category.listing_category_parent.id == 3) {
						locationIdForCardAds = 34;
						locationId = 36;
						this.category = 'carsEngines';
					}
					if (details.listing_category.listing_category_parent.id == 4) {
						locationIdForCardAds = 43;
						locationId = 45;
						this.category = 'findJob';
					}

					if (this.locationIdForCardAds != locationIdForCardAds) {
						this.locationIdForCardAds = locationIdForCardAds;
						this.getVerticleAds(locationIdForCardAds);
					}
					if (this.isMobile) {
						locationId = 49;
						this.getMobileAds(47);
					}
					this.getFooterAds(locationId);
				});
			} else {
				this.ADMIN_GET_LISTING_DETAIL({ id: this.$route.params.id });
			}

			if (this.$root.isAuthenticated) {
				this.GET_LISTING_INTERESTINGS({
					take: 4,
					page: 1
				});
				let user = JSON.parse(localStorage.getItem('user_profile'));
				if (user && user.id) {
					this.userLogin = user;
				}
			}
		},
		getFooterAds(locationId) {
			console.log('locationId', locationId);
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: locationId
			}).then(({ data }) => {
				if (data) {
					console.log('data', data);
					this.adsFooter = data;
					this.$forceUpdate();
				}
			});
		}
	},

	created() {
		this.getListingDetails();
	},
	computed: {
		...mapGetters('UserController', ['isMobile']),
		...mapState('ListingDetailController', [
			'listingDetailsFront',
			'showRejectAcceptButton',
			'listingInteresting',
			'listingSellerDetail'
		]),
		...mapGetters('ListingAdminController', ['listing', 'rejectStatus'])
	},
	watch: {
		$route(to, from) {
			this.getListingDetails();
			window.scroll(0, 0);
		},
		listingDetailsFront(val) {
			if (val) {
				this.listingDetails = val;
			}
		},
		listing(val) {
			if (val) {
				this.listingDetails = val;
			}
		},
		listingSellerDetail: function(val) {
			if (val.length > 2) {
				this.randomADSSellerDetail =
					val[Math.floor(Math.random() * val.length)].id;
			} else {
				this.randomADSSellerDetail = 0;
			}
		},
		listingInteresting: function(val) {
			if (val.length > 2) {
				this.randomADSInteresting =
					val[Math.floor(Math.random() * val.length)].id;
			} else {
				this.randomADSInteresting = 0;
			}
		},

		rejectStatus: function(val) {
			if (val && val.success) {
				this.hideModal();
				this.SET_ADMIN_REJECT_LISTING_STATUS({
					data: {}
				});
				this.$router.push(
					this.$i18nRoute({
						name: 'admin-approve-listing'
					})
				);
			}
		},
		//TODO is this used?
		isLogin: function(val) {
			if (val) {
				setTimeout(() => {
					this.userName = JSON.parse(
						localStorage.getItem('user_profile')
					).display_name;
				}, 500);
			}
		}
	},
	mounted() {
		this.ShowRejectAcceptButton = this.showRejectAcceptButton;
	},
	destroyed() {
		console.log('destroyed listing details');
		this.adsFooter = null;
	}
};
</script>
<style lang="scss" scopped>
@import 'listingDetail.scss';
</style>
